/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Low
 *
 * 1 = Good
 *
 * 2 = Fair
 *
 * 3 = Great
 *
 * 4 = High
 *
 * 5 = NoAnalysis
 */
export enum PriceIndicator {
  Low = 0,
  Good = 1,
  Fair = 2,
  Great = 3,
  High = 4,
  NoAnalysis = 5,
}
